// extracted by mini-css-extract-plugin
export default {"root":"UnavailablePersonalAccount_root__UIWiT","text":"UnavailablePersonalAccount_text__EZZNs","addNewAccountButton":"UnavailablePersonalAccount_addNewAccountButton__ncz5q"};